// Переключатель дизайна: classic (по умолчанию) / cp. Старая версия — plate.styled.classic.js, новая — plate.styled.cp.js
import { isCp } from 'libs/design';
import * as classic from './plate.styled.classic';
import * as cp from './plate.styled.cp';

export const Button = isCp ? cp.Button : classic.Button;
export const Content = isCp ? cp.Content : classic.Content;
export const Label = isCp ? cp.Label : classic.Label;
